import { render, staticRenderFns } from "./FilesViewer.vue?vue&type=template&id=4340a970"
import script from "./FilesViewer.vue?vue&type=script&lang=js"
export * from "./FilesViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports